import { render, staticRenderFns } from "./CreativesPreview.vue?vue&type=template&id=39a5c156&scoped=true&"
import script from "./CreativesPreview.vue?vue&type=script&lang=js&"
export * from "./CreativesPreview.vue?vue&type=script&lang=js&"
import style0 from "./CreativesPreview.vue?vue&type=style&index=0&id=39a5c156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5c156",
  null
  
)

export default component.exports